module.exports = __webpack_public_path__ + "static/case-dashboard-6d3b6fb06a5d55b9192ee22da0a6d539.png";